module.exports = __webpack_public_path__ + "f99502be98e1fc35040febb05eed01f1.svg";